// removed by extract-text-webpack-plugin
module.exports = {"tableFixed":"MantenedorDistancias__tableFixed___2-ImK","trSeparador":"MantenedorDistancias__trSeparador___1BRD6","colIndex":"MantenedorDistancias__colIndex___1Ao9j","thIndex":"MantenedorDistancias__thIndex___36Bhr","tdIndex":"MantenedorDistancias__tdIndex___1Ig5Q","colComuna":"MantenedorDistancias__colComuna___2zesy","thComuna":"MantenedorDistancias__thComuna___Tqhd-","tdComuna":"MantenedorDistancias__tdComuna___2Ix80"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/distancias/MantenedorDistancias.css
// module id = 1093
// module chunks = 0